export const getCookie = (name: string): string => {
  const nameLenPlus = name.length + 1;
  return (
    document.cookie
      .split(';')
      .map((c) => c.trim())
      .filter((cookie) => cookie.substring(0, nameLenPlus) === `${name}=`)
      .map((cookie) => {
        const value = decodeURIComponent(cookie.substring(nameLenPlus));
        return value.replace(/^"|"$/g, ''); // Strip surrounding quotes
      })[0] || ''
  );
};
